import React from "react";
import Person from "./Person";
import SubTitle from "../SubTitle";
class People extends React.Component {

    render() {
        let title;
        if(this.props.title) {
            title =   <SubTitle title={this.props.title} direction="left" />;
        }else{
            title = '';
        }

        return (
          <section className="rob-people">
              {title}
              <div className="container">
                  <div className="row">
                  {this.props.people.map(function (name, index) {
                      return  <Person key={index} {...name} />
                  })
                  }
                  </div>
              </div>
          </section>
        )
    }

}

export default People;




// WEBPACK FOOTER //
// ./src/components/elements/blockLoop/People.js